import { useQuery } from 'react-query'
import { IndividualBehavioralProfileResponse } from 'interfaces/behavioral-profile'

const { REACT_APP_PANOPTICON_CAN_SEND_BASE } = process.env

const fetchIndividualBehavioralProfile = async (
  systemUser: string,
  recipient: string
): Promise<IndividualBehavioralProfileResponse> => {
  if (!REACT_APP_PANOPTICON_CAN_SEND_BASE) {
    // Return empty response if API base URL not configured
    return {
      success: false,
      systemUser,
      recipient,
      profile: null,
    }
  }

  const encodedSystemUser = encodeURIComponent(systemUser)
  const encodedRecipient = encodeURIComponent(recipient)

  const url = `${REACT_APP_PANOPTICON_CAN_SEND_BASE}/permission-events/behavioral-profiles/${encodedSystemUser}/${encodedRecipient}`

  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`)
  }

  return response.json()
}

export const useIndividualBehavioralProfile = (
  systemUser: string,
  recipient: string,
  enabled = true
) => {
  return useQuery(
    ['individual-behavioral-profile', systemUser, recipient],
    () => fetchIndividualBehavioralProfile(systemUser, recipient),
    {
      enabled: enabled && !!systemUser && !!recipient,
      staleTime: 30000, // 30 seconds
      refetchOnWindowFocus: false,
    }
  )
}

export default useIndividualBehavioralProfile
